module.exports = __webpack_public_path__ + "static/media/3DPPA6.8e7d530b.jpg";